import createSerieData from "./createSerieData";
import { Serie } from "./types/Serie";

export default async function createSerie(firebase, data) {
	const serie = Serie.parse(createSerieData(firebase, data));
	await serie.ref.set(serie);
	return serie;
}
